import { gql } from '@apollo/client';
import gqlClient from '../../../../utils/apolloClient';

/**
 * Soft-delete mutations for menu items and categories (BLUM-5767).
 *
 * Records are never hard-deleted — instead `deleted_at` is stamped with the
 * current time so the row is hidden from the admin UI and the customer-facing
 * ordering platform while remaining available for historical orders. Restoring
 * simply clears `deleted_at` back to null.
 */

const setCategoryDeletedAtMutation = gql`
  mutation ($id: uuid!, $deletedAt: timestamptz) {
    update_categories_by_pk(pk_columns: { id: $id }, _set: { deleted_at: $deletedAt }) {
      id
    }
  }
`;

const setDishDeletedAtMutation = gql`
  mutation ($id: uuid!, $deletedAt: timestamptz) {
    update_dishes_by_pk(pk_columns: { id: $id }, _set: { deleted_at: $deletedAt }) {
      id
    }
  }
`;

const setDrinkDeletedAtMutation = gql`
  mutation ($id: uuid!, $deletedAt: timestamptz) {
    update_drinks_by_pk(pk_columns: { id: $id }, _set: { deleted_at: $deletedAt }) {
      id
    }
  }
`;

const ITEM_MUTATION = {
  dish: setDishDeletedAtMutation,
  drink: setDrinkDeletedAtMutation,
};

export type ItemType = 'dish' | 'drink';

export const softDeleteCategory = async (id: string) =>
  gqlClient.mutate({ mutation: setCategoryDeletedAtMutation, variables: { id, deletedAt: new Date().toISOString() } });

export const restoreCategory = async (id: string) => gqlClient.mutate({ mutation: setCategoryDeletedAtMutation, variables: { id, deletedAt: null } });

export const softDeleteItem = async (type: ItemType, id: string) =>
  gqlClient.mutate({ mutation: ITEM_MUTATION[type], variables: { id, deletedAt: new Date().toISOString() } });

export const restoreItem = async (type: ItemType, id: string) => gqlClient.mutate({ mutation: ITEM_MUTATION[type], variables: { id, deletedAt: null } });
